export default "__VITE_ASSET__Dv6MEJBW__"